import React, { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { CustomModal } from '../CustomModal';

interface Props {
  closeModal(): void;
  handlerDelete(): void;
}

export const DeleteModal: FC<Props> = ({ closeModal, handlerDelete }) => {
  return (
    <CustomModal title="Удаление чертежа-подложки" handleClose={closeModal} open={true}>
      <Stack flexDirection="row">
        <Typography fontSize="18px">Вы действительно хотите удалить чертеж-подложку?</Typography>
      </Stack>

      <Stack flexDirection="row" mt={5}>
        <Button
          onClick={closeModal}
          variant="contained"
          color="secondary"
          style={{
            width: '80%',
            height: '95%',
            marginRight: '2px',
          }}
        >
          <Typography>Отмена</Typography>
        </Button>
        <Button
          onClick={handlerDelete}
          variant="contained"
          color="error"
          style={{
            width: '80%',
            height: '95%',
            marginLeft: '2px',
          }}
        >
          <Typography>Удалить</Typography>
        </Button>
      </Stack>
    </CustomModal>
  );
};
